import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from '@angular/http';
import { Response } from '@angular/http';
import { DatePipe } from '@angular/common';
import 'rxjs/add/operator/map';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Personnel } from '../models/personnel';

@Injectable()
export class PersonnelService {

  public static NEPHOLOGUE_NOM = 'Nephrologue';
  public static Chirurgien_NOM = 'Chirurgien';
  private url = `/api/personnels`;

  constructor(private http: HttpClient) { }

  public find(specialite?: string): Observable<[Personnel]> {
   const params = new HttpParams()
     .set('size', 'page')
     .set('size', '50')
     .set('sortName', 'id')
     .set('sortType', 'DESC');
    if (specialite ) {
       params.set('specialite', specialite)
     }
   return this.http.get<[Personnel]>(this.url, { params: params });
  }
  /**
   * create a  new catalogue
   * @param personnel
   */

  create(personnel: Personnel) {
    return this.http.post(this.url, personnel)
      .map(
        (data) => {
          console.log(data);
        }
      );
  }

  delete(personnel: Personnel) {
    return this.http.delete(`${this.url}/${personnel.id}`)
      .map(
        (data) => {
          console.log(data);
        }
      );
  }

  update(personnel: Personnel) {
    return this.http.put(`${this.url}/${personnel.id}`, personnel)
      .map(
        (data) => {
          console.log(data);
        }
      );
  }
  /**
   * retourne les médecins autorisés pour les rdv
   */
  getMedecinsRV(): Observable<Personnel[]> {
    return this.http.get<Personnel[]>(`${this.url}/rv`).map(data => data);
  }

  /**
   * récupére le medecin correspondant au User userId
   * @param userId
   */
  getMedecin(userId: number): Observable<Personnel> {
    return this.http.get<Personnel>(`${this.url}/${userId}/medecin`).map(data => data)
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/personnels.service.ts